import Cookies from 'js-cookie';

export const setCookie = (name: string, value: string, options: Cookies.CookieAttributes | null = null): void => {
  if (name && value && options) {
    Cookies.set(name, value, options);
    return;
  }

  if (name && value) {
    Cookies.set(name, value);
  }
};

export function getCookies(name: string): string | undefined;
export function getCookies(): Record<string, string>;
export function getCookies(name?: string): string | undefined | Record<string, string> {
  if (name) {
    return Cookies.get(name);
  }

  return Cookies.get();
}

export const removeCookie = (name: string, options?: Cookies.CookieAttributes): void => {
  if (name && options) {
    Cookies.remove(name, options);
    return;
  }

  if (name) {
    Cookies.remove(name);
  }
};
